import React from 'react'
import { Routes, Route } from "react-router-dom";
import Home from "./Components/LandingPage/Home"
import AboutSection from './Components/LandingPage/AboutSection';
import Contactus from './Components/LandingPage/Contactus';
import Deleteaccount from './Components/LandingPage/Deleteaccount';
import Term from './Components/LandingPage/Term';
import PrivacyPolicy from './Components/LandingPage/PrivacyPolicy';
import EnterpriseMain from './Components/EnterPrise/EnterpriseMain';
import DriverPartnerMain from './Components/DriverPartner/DriverPartnerMain';
import Article from './Components/LandingPage/Article';
import Gateway from './Components/Login/Gateway';
import AllBlogs from './Components/LandingPage/AllBlogs';
import Address from './Components/Client Section/Address/Address';
import Bookings from './Components/Client Section/Booking/Cards/Bookings';
import TrackingOrderCard from './Components/Client Section/Booking/Cards/TrackingOrderCard/TrackingOrderCard';
import VehicleFareCard from './Components/Client Section/Booking/Cards/VehicleFareCard/VehicleFareCard';
import CaptainSearchingCard from './Components/Client Section/Booking/Cards/CaptainSearchingCard/CaptainSearchingCard';


const App = () => {
  return (
    <Routes>
    <Route path="/" element={<Home />} />
    <Route path='/about-us' element={<AboutSection />} />
    <Route path='/contact-us' element={<Contactus />} />
    <Route path='/blog-section' element={<AllBlogs />} />
    <Route path='/delete-account' element={<Deleteaccount />} />
    <Route path='/term-condition' element={<Term/>} />
    <Route path='/privacy-policy' element={<PrivacyPolicy />} />
    <Route path='/enterprise' element={<EnterpriseMain />} />
    <Route path='/driver-partner' element={<DriverPartnerMain />} />
    <Route path="/blog/:post_slug" element={<Article />} />
    <Route path='/bookings' element={<Bookings />} />
    <Route path='/tracking-order-card' element={<TrackingOrderCard />} />
    <Route path='/vehicle-fare-card' element={<VehicleFareCard />} />
    <Route path='/captain-searching-card' element={<CaptainSearchingCard />} />
     <Route path="/gateway" element={<Gateway />} />
     <Route path="/address" element={<Address />} />
    </Routes>
  )
}

export default App
